export default __webpack_public_path__ + "static/media/Notebook.88e9b184.png";